export default __webpack_public_path__ + "static/media/Rectangle 410.615ae636.png";